import { render, staticRenderFns } from "./newemployees.vue?vue&type=template&id=3cb03fb5&scoped=true"
import script from "./newemployees.vue?vue&type=script&lang=js"
export * from "./newemployees.vue?vue&type=script&lang=js"
import style0 from "./newemployees.vue?vue&type=style&index=0&id=3cb03fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb03fb5",
  null
  
)

export default component.exports